import type { Dispatch, ReactNode, SetStateAction } from 'react'
import Link from 'next/link'
import Logo from '../../svg/Logo'
import clsx from 'clsx'

export default function Header({
	children,
	setIsMegaMenuOpen,
	setCurrentDropdown,
	setActiveMegaMenu,
}: Readonly<{
	children: ReactNode
	setIsMegaMenuOpen: Dispatch<SetStateAction<boolean>>
	setCurrentDropdown: (currentDropdown: string | null) => void
	setActiveMegaMenu: (activeMegaMenu: string | null) => void
}>) {
	const handleLogoClick = () => {
		setIsMegaMenuOpen(false)
		setCurrentDropdown(null)
		setActiveMegaMenu(null)
	}

	return (
		<header
			className={clsx(
				'fixed top-0 w-full h-[--nav-height] py-3.5 z-50',
				'before:content-[""] before:absolute before:inset-0 before:bg-white before:border-b before:z-[-2]'
			)}
		>
			<div
				className={clsx(
					'relative flex items-center justify-between w-full common-x-padding',
					'transition-colors duration-500 ease-in-out [&>nav]:text-contrast'
				)}
			>
				{/* Logo */}
				<Link
					href="/"
					className={clsx(
						'absolute w-fit duration-500 ease-in-out lg:left-1/2 lg:-translate-x-1/2',
						'text-blue hover:text-blue-shade'
					)}
					aria-label="Navigate to home"
					onClick={handleLogoClick}
				>
					<Logo className="max-sm:-translate-x-4 max-lg:py-2 py-1" />
				</Link>

				{/* Nav & CTA Button */}
				{children}
			</div>
		</header>
	)
}
